
import { Component, Prop, Vue } from 'vue-property-decorator'
import InvoiceCreatorDialog from '@/components/Transport/Accounting/InvoiceCreatorDialog.vue'
import InvoiceType from '@/enums/InvoiceType'

@Component({
	components: { InvoiceCreatorDialog }
})
export default class InvoiceCreateDialog extends Vue {
	@Prop({ required: true })
	show!: boolean

	@Prop({ required: false, default: InvoiceType.SALES })
	invoiceType!: InvoiceType

	invoiceKey: number = 0
	invoiceCreatorPreview: boolean = false

	get isOpen(): boolean {
		return this.show
	}

	onClosed() {
		this.invoiceCreatorPreview = false
		this.$emit('close')
	}

	onInvoiceCreated() {
		this.invoiceCreatorPreview = false
		this.invoiceKey++
		this.$emit('saved')
		this.$emit('close')
	}
}
